export default `
  query consultaCategorias($categoria: String!) {
    consultaCategorias(categoria: $categoria) {
      descricao
      id
    }
  }
`